import React from 'react';
import PropTypes from 'prop-types';

const ContentSuccess = (props) => {
    return (
        <div className={'new-modal-container'}>
            <div className={'new-modal-scroll'}>
                <div className='new-modal-title'>Pedido anulado</div>
                <div className="order-cancel-success-info">
                    <p>Tu pedido está en proceso de anulación. Puedes revisarlo en la sección <strong>Mis Compras</strong></p>
                </div>
            </div>

            <div className={'modal-actions'}>
                <button className="primary-btn btn-order-cancel" onClick={() => props.closeOrderCancel()}>Aceptar</button>
            </div>
        </div>
    )
}

ContentSuccess.propTypes = {
    closeOrderCancel: PropTypes.func
}

export default ContentSuccess;